module.exports = __webpack_public_path__ + "media/images/icon_burger-18d0b157545470084fde4201b78e1b51.svg";